// import { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FaEdit,
//   FaTrash,
//   FaPlus,
//   FaSearch,
//   FaUsers,
//   FaUserPlus,
//   FaUserMinus,
// } from "react-icons/fa";
// import Card from "../admincomponents/Card";
// import Table from "../admincomponents/Table";

// const GroupManagement = () => {
//   const [groupsData, setGroupsData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [showMembersModal, setShowMembersModal] = useState(false);
//   const [currentGroup, setCurrentGroup] = useState(null);
//   const [viewMode, setViewMode] = useState("list"); // "list" or "card"

//   const [formData, setFormData] = useState({
//     name: "",
//     description: "",
//   });

//   useEffect(() => {
//     fetchGroups();
//   }, []);

//   const fetchGroups = async () => {
//     try {
//       const token = localStorage.getItem("jwttoken");
//       const res = await axios.get(
//         "https://kaasbackend.vetrinahealthcare.com/socialapp/groups/",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const formatted = res.data.map((group) => ({
//         id: group.id,
//         name: group.name,
//         description: group.description,
//         members: group.members.length,
//         createdAt: new Date(group.created_at).toLocaleDateString(),
//         membersList: group.members.map((m) => ({
//           id: m.user_id,
//           name: `${m.first_name} ${m.last_name}`,
//           email: m.email,
//           role: "Member",
//         })),
//       }));
//       setGroupsData(formatted);
//     } catch (err) {
//       console.error("Failed to fetch groups:", err);
//     }
//   };

//   const filteredGroups = groupsData.filter((group) =>
//     [group.name, group.description]
//       .join(" ")
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleAddSubmit = (e) => {
//     e.preventDefault();
//     console.log("Adding group:", formData);
//     setShowAddModal(false);
//     setFormData({ name: "", description: "",  });
//   };

//   const handleEditSubmit = (e) => {
//     e.preventDefault();
//     console.log("Editing group:", currentGroup.id, formData);
//     setShowEditModal(false);
//   };

//   const handleDeleteConfirm = () => {
//     console.log("Deleting group:", currentGroup.id);
//     setShowDeleteModal(false);
//   };

//   const handleEditClick = (group) => {
//     setCurrentGroup(group);
//     setFormData({
//       name: group.name,
//       description: group.description,
//     });
//     setShowEditModal(true);
//   };

//   const handleDeleteClick = (group) => {
//     setCurrentGroup(group);
//     setShowDeleteModal(true);
//   };

//   const handleMembersClick = (group) => {
//     setCurrentGroup(group);
//     setShowMembersModal(true);
//   };

//   const handleRemoveMember = (member) => {
//     console.log("Removing member:", member.id, "from group:", currentGroup.id);
//   };

//   const iconButtonStyle = {
//     background: "none",
//     border: "none",
//     color: "#7366ff",
//     cursor: "pointer",
//     fontSize: "16px",
//   };

//   const columns = [
//     { key: "name", label: "Group Name", sortable: true },
//     { key: "description", label: "Description", sortable: true },
//     {
//       key: "members",
//       label: "Members",
//       sortable: true,
//       render: (row) => (
//         <button
//           onClick={() => handleMembersClick(row)}
//           style={{
//             background: "none",
//             border: "none",
//             color: "#7366ff",
//             cursor: "pointer",
//             textDecoration: "underline",
//             fontWeight: "bold",
//           }}
//         >
//           {row.members}
//         </button>
//       ),
//     },
//     { key: "createdAt", label: "Created At", sortable: true },
//     {
//       key: "actions",
//       label: "Actions",
//       sortable: false,
//       render: (row) => (
//         <div style={{ display: "flex", gap: "10px" }}>
//           <button onClick={() => handleEditClick(row)} style={iconButtonStyle}>
//             <FaEdit />
//           </button>
//           <button
//             onClick={() => handleDeleteClick(row)}
//             style={{ ...iconButtonStyle, color: "#ff5370" }}
//           >
//             <FaTrash />
//           </button>
//         </div>
//       ),
//     },
//   ];

//   const membersColumns = [
//     { key: "name", label: "Name", sortable: true },
//     { key: "email", label: "Email", sortable: true },
//     { key: "role", label: "Role", sortable: true },
//     {
//       key: "actions",
//       label: "Actions",
//       sortable: false,
//       render: (row) => (
//         <button
//           onClick={() => handleRemoveMember(row)}
//           style={{ ...iconButtonStyle, color: "#ff5370" }}
//         >
//           <FaUserMinus />
//         </button>
//       ),
//     },
//   ];

//   const modalBackdropStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1000,
//   };

//   const modalContentStyle = {
//     backgroundColor: "white",
//     borderRadius: "10px",
//     padding: "20px",
//     width: "500px",
//     maxWidth: "90%",
//     maxHeight: "90vh",
//     overflowY: "auto",
//   };

//   return (
//     <div>
//       <h1 style={{ marginBottom: "20px", color: "#333" }}>
//         Group Management
//       </h1>

//       <Card>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "15px",
//             marginBottom: "20px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               position: "relative",
//               width: "300px",
//             }}
//           >
//             <FaSearch
//               style={{ position: "absolute", left: "10px", color: "#888" }}
//             />
//             <input
//               type="text"
//               placeholder="Search groups..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: "8px 10px 8px 35px",
//                 border: "1px solid #ddd",
//                 borderRadius: "5px",
//                 width: "100%",
//               }}
//             />
//           </div>

//           <button
//             onClick={() => setShowAddModal(true)}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "5px",
//               padding: "8px 15px",
//               background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//               color: "white",
//               border: "none",
//               borderRadius: "5px",
//               cursor: "pointer",
//             }}
//           >
//             <FaPlus />
//             Create Group
//           </button>
//         </div>

//         <Table
//           columns={columns}
//           data={filteredGroups}
//           pagination={true}
//           itemsPerPage={5}
//         />
//       </Card>

//       {showAddModal && (
//         <Modal
//           title="Create New Group"
//           onClose={() => setShowAddModal(false)}
//           onSubmit={handleAddSubmit}
//           formData={formData}
//           onChange={handleInputChange}
//         />
//       )}
//       {showEditModal && (
//         <Modal
//           title="Edit Group"
//           onClose={() => setShowEditModal(false)}
//           onSubmit={handleEditSubmit}
//           formData={formData}
//           onChange={handleInputChange}
//         />
//       )}
//       {showDeleteModal && (
//         <ConfirmDeleteModal
//           group={currentGroup}
//           onCancel={() => setShowDeleteModal(false)}
//           onConfirm={handleDeleteConfirm}
//         />
//       )}
//       {showMembersModal && (
//         <div style={modalBackdropStyle}>
//           <div style={{ ...modalContentStyle, width: "600px" }}>
//             <h2 style={{ marginBottom: "20px" }}>
//               Members of {currentGroup?.name}
//             </h2>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginBottom: "20px",
//               }}
//             >
//               <div>Total Members: {currentGroup?.members}</div>
//               <button
//                 style={{
//                   ...iconButtonStyle,
//                   background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//                   color: "#fff",
//                   borderRadius: "5px",
//                   padding: "8px 10px",
//                 }}
//               >
//                 <FaUserPlus />
//                 Add Member
//               </button>
//             </div>
//             <Table
//               columns={membersColumns}
//               data={currentGroup?.membersList || []}
//               pagination={false}
//             />
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 marginTop: "20px",
//               }}
//             >
//               <button
//                 onClick={() => setShowMembersModal(false)}
//                 style={{
//                   padding: "8px 15px",
//                   background: "#f5f5f5",
//                   border: "1px solid #ddd",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const Modal = ({ title, onSubmit, onClose, formData, onChange }) => (
//   <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       backgroundColor: "rgba(0,0,0,0.5)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       zIndex: 1000,
//     }}
//   >
//     <div
//       style={{
//         backgroundColor: "white",
//         borderRadius: "10px",
//         padding: "20px",
//         width: "500px",
//         maxWidth: "90%",
//         maxHeight: "90vh",
//         overflowY: "auto",
//       }}
//     >
//       <h2 style={{ marginBottom: "20px" }}>{title}</h2>
//       <form onSubmit={onSubmit}>
//         <div style={{ marginBottom: "15px" }}>
//           <label style={{ display: "block", marginBottom: "5px" }}>
//             Group Name
//           </label>
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             onChange={onChange}
//             required
//             style={inputStyle}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <label style={{ display: "block", marginBottom: "5px" }}>
//             Description
//           </label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={onChange}
//             style={{ ...inputStyle, minHeight: "80px" }}
//           />
//         </div>
//         <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
//           <button type="button" onClick={onClose} style={cancelButtonStyle}>
//             Cancel
//           </button>
//           <button type="submit" style={submitButtonStyle}>
//             Save
//           </button>
//         </div>
//       </form>
//     </div>
//   </div>
// );

// const ConfirmDeleteModal = ({ group, onCancel, onConfirm }) => (
//   <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       backgroundColor: "rgba(0,0,0,0.5)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       zIndex: 1000,
//     }}
//   >
//     <div
//       style={{
//         backgroundColor: "white",
//         borderRadius: "10px",
//         padding: "20px",
//         width: "400px",
//       }}
//     >
//       <h2>Confirm Delete</h2>
//       <p>
//         Are you sure you want to delete <strong>{group?.name}</strong>?
//       </p>
//       <div
//         style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}
//       >
//         <button onClick={onCancel} style={cancelButtonStyle}>
//           Cancel
//         </button>
//         <button
//           onClick={onConfirm}
//           style={{ ...submitButtonStyle, background: "#ff5370" }}
//         >
//           Delete
//         </button>
//       </div>
//     </div>
//   </div>
// );

// const inputStyle = {
//   width: "100%",
//   padding: "8px 10px",
//   border: "1px solid #ddd",
//   borderRadius: "5px",
// };

// const cancelButtonStyle = {
//   padding: "8px 15px",
//   background: "#f5f5f5",
//   border: "1px solid #ddd",
//   borderRadius: "5px",
//   cursor: "pointer",
// };

// const submitButtonStyle = {
//   padding: "8px 15px",
//   background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//   color: "white",
//   border: "none",
//   borderRadius: "5px",
//   cursor: "pointer",
// };

//export default GroupManagement;

import { useEffect, useState } from "react";
import axios from "axios";
import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaSearch,
  FaUserMinus,
  FaUserPlus,
  FaList,
  FaTh,
  FaUser,
} from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import Swal from "sweetalert2";

const GroupManagement = () => {
  const [groupsData, setGroupsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMembersModal, setShowMembersModal] = useState(false);
  const [currentGroup, setCurrentGroup] = useState(null);
  const [viewMode, setViewMode] = useState("card");
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    privacy: "public",
    post_permission: "admin_only",
    invite_permission: "user",
  });

  const backendURL = "https://kaasbackend.vetrinahealthcare.com";
  const token = localStorage.getItem("jwttoken");

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${backendURL}/socialapp/groups/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const formatted = response.data.map((group) => ({
        id: group.id,
        name: group.name,
        description: group.description,
        members: group.members?.length || 0,
        createdAt: new Date(group.created_at).toLocaleDateString(),
        membersList:
          group.members?.map((m) => ({
            id: m.user_id,
            name: `${m.first_name} ${m.last_name}`,
            email: m.email,
            role: "Member",
            profilePic: m.profile_pic
              ? `${backendURL}/lms/media/profile_pics/${m.profile_pic
                  .split("/")
                  .pop()}`
              : null,
          })) || [],
        cover_photo: group.cover_photo
          ? `${backendURL}/lms/media/group_covers/${group.cover_photo
              .split("/")
              .pop()}`
          : "https://placehold.co/600x300?text=Group+Cover&font=roboto",
        created_by: group.created_by,
        privacy: group.privacy,
        is_active: group.is_active,
        post_permission: group.post_permission,
        invite_permission: group.invite_permission,
      }));

      setGroupsData(formatted);
    } catch (err) {
      console.error("Failed to fetch groups:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load groups. Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const filteredGroups = groupsData.filter((group) =>
    [group.name, group.description]
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await axios.post(`${backendURL}/socialapp/groups/`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Group created successfully.",
      });
      setShowAddModal(false);
      setFormData({
        name: "",
        description: "",
        privacy: "public",
        post_permission: "admin_only",
        invite_permission: "user",
      });
      fetchGroups();
    } catch (error) {
      console.error("Error creating group:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create group. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await axios.put(
        `${backendURL}/socialapp/groups/${currentGroup.id}/`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Group updated successfully.",
      });
      setShowEditModal(false);
      fetchGroups();
    } catch (error) {
      console.error("Error updating group:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update group. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      setIsLoading(true);
      await axios.delete(`${backendURL}/socialapp/groups/${currentGroup.id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Group deleted successfully.",
      });
      setShowDeleteModal(false);
      fetchGroups();
    } catch (error) {
      console.error("Error deleting group:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete group. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = (group) => {
    setCurrentGroup(group);
    setFormData({
      name: group.name,
      description: group.description,
      privacy: group.privacy,
      post_permission: group.post_permission,
      invite_permission: group.invite_permission,
    });
    setShowEditModal(true);
  };

  const handleDeleteClick = (group) => {
    setCurrentGroup(group);
    setShowDeleteModal(true);
  };

  const handleMembersClick = (group) => {
    setCurrentGroup(group);
    setShowMembersModal(true);
  };

  const handleRemoveMember = async (member) => {
    try {
      setIsLoading(true);
      await axios.delete(
        `${backendURL}/socialapp/group_memberships/${currentGroup.id}/remove_member/${member.id}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Member removed successfully.",
      });
      fetchGroups();
    } catch (error) {
      console.error("Error removing member:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to remove member. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const GroupCard = ({ group, onEdit, onDelete, onMembers }) => (
    <div className="group-card">
      <div className="group-cover-container">
        <img
          src={group.cover_photo}
          alt={group.name}
          className="group-cover-image"
          onError={(e) => {
            e.target.src =
              "https://placehold.co/600x300?text=Group+Cover&font=roboto";
          }}
        />
        <div className="group-privacy-badge">
          {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
        </div>
      </div>

      <div className="group-card-content">
        <h4 className="group-title">
          <span
            className={`group-status-indicator ${
              group.is_active ? "active" : "inactive"
            }`}
          ></span>
          {group.name}
        </h4>
        <p className="group-description">
          {group.description || "No description provided"}
        </p>
        <div className="group-meta">
          <div>
            <strong>Members:</strong>{" "}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onMembers(group);
              }}
              className="members-link"
            >
              {group.members}
            </button>
          </div>
          <div className="group-created-info">
            <div>
              Created by: {group.created_by?.first_name || "Unknown"}{" "}
              {group.created_by?.last_name || ""}
            </div>
            <div>{group.createdAt}</div>
          </div>
        </div>
        <div className="group-actions">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEdit(group);
            }}
            className="action-button edit-button"
            title="Edit"
          >
            <FaEdit />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(group);
            }}
            className="action-button delete-button"
            title="Delete"
          >
            <FaTrash />
          </button>
        </div>
      </div>
    </div>
  );

  const columns = [
    { key: "name", label: "Group Name", sortable: true },
    { key: "description", label: "Description", sortable: true },
    {
      key: "members",
      label: "Members",
      sortable: true,
      render: (row) => (
        <button
          onClick={() => handleMembersClick(row)}
          className="members-link"
        >
          {row.members}
        </button>
      ),
    },
    { key: "createdAt", label: "Created At", sortable: true },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (row) => (
        <div className="table-actions">
          <button
            onClick={() => handleEditClick(row)}
            className="action-button edit-button"
            title="Edit"
          >
            <FaEdit />
          </button>
          <button
            onClick={() => handleDeleteClick(row)}
            className="action-button delete-button"
            title="Delete"
          >
            <FaTrash />
          </button>
        </div>
      ),
    },
  ];

  const membersColumns = [
    { key: "name", label: "Name", sortable: true },
    { key: "email", label: "Email", sortable: true },
    { key: "role", label: "Role", sortable: true },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (row) => (
        <button
          onClick={() => handleRemoveMember(row)}
          style={{
            background: "none",
            border: "none",
            color: "#ff5370",
            cursor: "pointer",
            fontSize: "16px",
            padding: "5px",
            transition: "all 0.2s ease",
          }}
          title="Remove Member"
        >
          <FaUserMinus />
        </button>
      ),
    },
  ];

  return (
    <div className="group-management-container">
      <div className="group-header">
        <h1>Group Management</h1>

        <div className="header-controls">
          <div className="search-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search groups..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

          <div className="view-toggle">
            <button
              onClick={() => setViewMode("list")}
              className={`view-button ${viewMode === "list" ? "active" : ""}`}
              title="List View"
            >
              <FaList />
            </button>
            <button
              onClick={() => setViewMode("card")}
              className={`view-button ${viewMode === "card" ? "active" : ""}`}
              title="Card View"
            >
              <FaTh />
            </button>
          </div>

          <button
            onClick={() => setShowAddModal(true)}
            className="create-group-button"
          >
            <FaPlus />
            Create Group
          </button>
        </div>
      </div>

      <div className="group-content">
        {isLoading ? (
          <div className="loading-container">
            <PulseLoader color="#7366ff" size={15} />
          </div>
        ) : viewMode === "list" ? (
          <table className="groups-table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredGroups.map((row) => (
                <tr key={row.id}>
                  {columns.map((column) => (
                    <td key={column.key}>
                      {column.render ? column.render(row) : row[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="group-card-container">
            {filteredGroups.length > 0 ? (
              filteredGroups.map((group) => (
                <GroupCard
                  key={group.id}
                  group={group}
                  onEdit={handleEditClick}
                  onDelete={handleDeleteClick}
                  onMembers={handleMembersClick}
                />
              ))
            ) : (
              <div className="empty-state">
                No groups found. Create your first group!
              </div>
            )}
          </div>
        )}
      </div>

      {/* Add Group Modal */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Create New Group</h2>
              <button
                onClick={() => setShowAddModal(false)}
                className="close-button"
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleAddSubmit}>
              <div className="form-group">
                <label>Group Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter group name"
                />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter group description (optional)"
                />
              </div>
              <div className="form-group">
                <label>Privacy</label>
                <select
                  name="privacy"
                  value={formData.privacy}
                  onChange={handleInputChange}
                >
                  <option value="public">Public</option>
                  <option value="private">Private</option>
                </select>
              </div>
              <div className="form-group">
                <label>Post Permission</label>
                <select
                  name="post_permission"
                  value={formData.post_permission}
                  onChange={handleInputChange}
                >
                  <option value="admin_only">Admin Only</option>
                  <option value="all_members">All Members</option>
                </select>
              </div>
              <div className="form-group">
                <label>Invite Permission</label>
                <select
                  name="invite_permission"
                  value={formData.invite_permission}
                  onChange={handleInputChange}
                >
                  <option value="admin_only">Admin Only</option>
                  <option value="user">All Members</option>
                </select>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  className="cancel-button"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={isLoading}
                >
                  {isLoading ? "Creating..." : "Create Group"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Group Modal */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Edit Group</h2>
              <button
                onClick={() => setShowEditModal(false)}
                className="close-button"
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleEditSubmit}>
              <div className="form-group">
                <label>Group Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter group name"
                />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter group description (optional)"
                />
              </div>
              <div className="form-group">
                <label>Privacy</label>
                <select
                  name="privacy"
                  value={formData.privacy}
                  onChange={handleInputChange}
                >
                  <option value="public">Public</option>
                  <option value="private">Private</option>
                </select>
              </div>
              <div className="form-group">
                <label>Post Permission</label>
                <select
                  name="post_permission"
                  value={formData.post_permission}
                  onChange={handleInputChange}
                >
                  <option value="admin_only">Admin Only</option>
                  <option value="all_members">All Members</option>
                </select>
              </div>
              <div className="form-group">
                <label>Invite Permission</label>
                <select
                  name="invite_permission"
                  value={formData.invite_permission}
                  onChange={handleInputChange}
                >
                  <option value="admin_only">Admin Only</option>
                  <option value="user">All Members</option>
                </select>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => setShowEditModal(false)}
                  className="cancel-button"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={isLoading}
                >
                  {isLoading ? "Updating..." : "Update Group"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-content delete-modal">
            <h2>Confirm Deletion</h2>
            <p>
              Are you sure you want to delete the group "{currentGroup?.name}"?
              This action cannot be undone.
            </p>
            <div className="modal-footer">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="cancel-button"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className="delete-confirm-button"
                disabled={isLoading}
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Members Modal */}
      {showMembersModal && (
        <div className="modal-overlay">
          <div className="modal-content members-modal">
            <div className="modal-header">
              <h2>
                Members of {currentGroup?.name}
                <span className="member-count">
                  ({currentGroup?.members} members)
                </span>
              </h2>
              <button
                onClick={() => setShowMembersModal(false)}
                className="close-button"
              >
                &times;
              </button>
            </div>

            <div className="members-content">
              <div className="members-search-container">
                <FaSearch className="search-icon" />
                <input type="text" placeholder="Search members..." />
              </div>

              <div className="members-header">
                <div className="showing-members">
                  Showing {currentGroup?.membersList?.length || 0} members
                </div>
                <button className="add-members-button">
                  <FaUserPlus />
                  Add Members
                </button>
              </div>

              <table className="members-table">
                <thead>
                  <tr>
                    {membersColumns.map((column) => (
                      <th key={column.key}>{column.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {currentGroup?.membersList?.map((member) => (
                    <tr key={member.id}>
                      {membersColumns.map((column) => (
                        <td key={column.key}>
                          {column.render
                            ? column.render(member)
                            : member[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              {currentGroup?.membersList?.length === 0 && (
                <div className="empty-members">
                  No members found in this group.
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        /* Base Styles */
        .group-management-container {
          padding: 25px;
          max-width: 1400px;
          margin: 0 auto;
        }

        .group-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
          flex-wrap: wrap;
          gap: 15px;
        }

        .group-header h1 {
          margin: 0;
          color: #333;
          font-size: 28px;
          font-weight: 600;
        }

        .header-controls {
          display: flex;
          gap: 15px;
          align-items: center;
          flex-wrap: wrap;
        }

        /* Search Input */
        .search-container {
          position: relative;
          width: 250px;
        }

        .search-icon {
          position: absolute;
          top: 12px;
          left: 12px;
          color: #888;
        }

        .search-input {
          padding: 10px 15px 10px 40px;
          border: 1px solid #ddd;
          border-radius: 8px;
          width: 100%;
          font-size: 14px;
          transition: all 0.2s ease;
        }

        .search-input:focus {
          border-color: #7366ff;
          outline: none;
          box-shadow: 0 0 0 3px rgba(115, 102, 255, 0.1);
        }

        /* View Toggle */
        .view-toggle {
          display: flex;
          gap: 10px;
          background: #f5f5f5;
          border-radius: 8px;
          padding: 4px;
        }

        .view-button {
          padding: 8px 12px;
          border: none;
          border-radius: 6px;
          background: transparent;
          color: #555;
          cursor: pointer;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
        }

        .view-button.active {
          background: #7366ff;
          color: #fff;
        }

        /* Create Group Button */
        .create-group-button {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 16px;
          background: linear-gradient(135deg, #7366ff, #8e63ff);
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .create-group-button:hover {
          background: linear-gradient(135deg, #6355e6, #7d52e6);
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(115, 102, 255, 0.2);
        }

        /* Group Content */
        .group-content {
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          overflow: hidden;
          background-color: #fff;
          padding: 20px;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 40px;
        }

        /* Group Cards */
        .group-card-container {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 20px;
          width: 100%;
        }

        .group-card {
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          padding: 0;
          background: #fff;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          height: 100%;
          display: flex;
          flex-direction: column;
          transition: all 0.3s ease;
        }

        .group-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          border-color: #7366ff;
        }

        .group-cover-container {
            position: relative;

          aspect-ratio: 16/9; 
          width: 100%;
          overflow: hidden;
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
          position: relative;
          background-color: #f5f5f5; /* fallback background */
        }

        .group-cover-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
          transition: transform 0.3s ease;
        }
        .group-card:hover .group-cover-image {
          transform: scale(1.03);
        }

        .group-privacy-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          padding: 4px 8px;
          border-radius: 16px;
          font-size: 12px;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(5px);
          text-transform: uppercase;
          color: white;
        }

        .group-card-content {
          padding: 20px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }

        .group-title {
          margin: 0 0 10px 0;
          color: #333;
          font-size: 18px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .group-status-indicator {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          display: inline-block;
        }

        .group-status-indicator.active {
          background: #4caf50;
        }

        .group-status-indicator.inactive {
          background: #ff5722;
        }

        .group-description {
          font-size: 14px;
          color: #555;
          flex-grow: 1;
          margin: 0 0 15px 0;
          line-height: 1.5;
        }

        .group-meta {
          margin: 10px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .members-link {
          background: none;
          border: none;
          color: #7366ff;
          cursor: pointer;
          text-decoration: underline;
          font-weight: bold;
          padding: 0;
          margin-left: 5px;
          transition: all 0.2s ease;
        }

        .members-link:hover {
          color: #5a4dff;
        }

        .group-created-info {
          font-size: 12px;
          color: #888;
          text-align: right;
        }

        .group-actions {
          display: flex;
          gap: 10px;
          margin-top: auto;
          border-top: 1px solid #eee;
          padding-top: 15px;
          justify-content: flex-end;
        }

        .action-button {
          background: none;
          border: none;
          cursor: pointer;
          font-size: 16px;
          padding: 5px;
          transition: all 0.2s ease;
        }

        .action-button:hover {
          transform: scale(1.1);
        }

        .edit-button {
          color: #7366ff;
        }

        .delete-button {
          color: #ff5370;
        }

        .remove-button {
          color: #ff5370;
        }

        /* Table View */
        .groups-table {
          width: 100%;
          border-collapse: collapse;
        }

        .groups-table th {
          padding: 12px 15px;
          text-align: left;
          font-weight: 600;
          color: #555;
          background-color: #f9f9f9;
          border-bottom: 1px solid #eee;
        }

        .groups-table td {
          padding: 12px 15px;
          vertical-align: middle;
          border-bottom: 1px solid #eee;
        }

        .groups-table tr:hover {
          background-color: #f9f9f9;
        }

        .table-actions {
          display: flex;
          gap: 10px;
        }

        /* Members Table */
        .members-table {
          width: 100%;
          border-collapse: collapse;
        }

        .members-table th {
          padding: 12px 15px;
          text-align: left;
          font-weight: 600;
          color: #555;
          background-color: #f9f9f9;
          border-bottom: 1px solid #eee;
        }

        .members-table td {
          padding: 12px 15px;
          vertical-align: middle;
          border-bottom: 1px solid #eee;
        }

        .members-table tr:hover {
          background-color: #f9f9f9;
        }

        .member-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f0f0f0;
        }

        .member-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .member-avatar svg {
          color: #666;
        }

        /* Empty States */
        .empty-state,
        .empty-members {
          grid-column: 1 / -1;
          text-align: center;
          padding: 40px;
          color: #666;
        }

        /* Modals */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal-content {
          background-color: white;
          border-radius: 12px;
          padding: 25px;
          width: 500px;
          max-width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        }

        .delete-modal {
          width: 400px;
        }

        .members-modal {
          width: 800px;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .modal-header h2 {
          margin: 0;
        }

        .close-button {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          color: #888;
        }

        .member-count {
          font-size: 14px;
          font-weight: normal;
          color: #666;
          margin-left: 10px;
        }

        /* Form Groups */
        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: #555;
        }

        .form-group input,
        .form-group textarea,
        .form-group select {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.2s ease;
        }

        .form-group input:focus,
        .form-group textarea:focus,
        .form-group select:focus {
          border-color: #7366ff;
          outline: none;
          box-shadow: 0 0 0 3px rgba(115, 102, 255, 0.1);
        }

        .form-group textarea {
          min-height: 100px;
        }

        /* Modal Footer */
        .modal-footer {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .cancel-button {
          padding: 10px 18px;
          background: #f5f5f5;
          border: 1px solid #ddd;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .cancel-button:hover {
          background: #e9e9e9;
        }

        .submit-button {
          padding: 10px 18px;
          background: linear-gradient(135deg, #7366ff, #8e63ff);
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .submit-button:hover {
          background: linear-gradient(135deg, #6355e6, #7d52e6);
          transform: translateY(-1px);
        }

        .submit-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .delete-confirm-button {
          padding: 10px 18px;
          background: #ff5370;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .delete-confirm-button:hover {
          background: #e64562;
          transform: translateY(-1px);
        }

        /* Members Content */
        .members-content {
          margin-bottom: 20px;
        }

        .members-search-container {
          position: relative;
          width: 100%;
          max-width: 400px;
          margin-bottom: 20px;
        }

        .members-search-container input {
          padding: 10px 15px 10px 40px;
          border: 1px solid #ddd;
          border-radius: 8px;
          width: 100%;
          font-size: 14px;
          transition: all 0.2s ease;
        }

        .members-search-container input:focus {
          border-color: #7366ff;
          outline: none;
          box-shadow: 0 0 0 3px rgba(115, 102, 255, 0.1);
        }

        .members-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .showing-members {
          font-size: 14px;
          color: #666;
        }

        .add-members-button {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 12px;
          background: linear-gradient(135deg, #7366ff, #8e63ff);
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.2s ease;
        }

        .add-members-button:hover {
          background: linear-gradient(135deg, #6355e6, #7d52e6);
        }
      `}</style>
    </div>
  );
};

export default GroupManagement;
